export const enum Actions {
  InviteUsers = 'InviteUsers',
  AssignManager = 'AssignManager',
  AssignDepartment = 'AssignDepartment',
  AssignLocation = 'AssignLocation',
  SetTimeOffLimit = 'SetTimeOffLimit',
}
